import React from 'react';
import PropTypes from 'prop-types';
import WithImpressions from '../../../WithImpressions';

export default function Test({ title, score, status, biData }) {
    const scoreFragment = score / 10,
        statusClassname = `status ${status}`,
        statusText = i18n.t(`seller_profile.skill_status.${status}`);

    const baseBiData = {
            type: 'seller_page.show$viewport',
            seller: {
                id: biData.sellerId
            },
            page: {
                ctx_id: biData.pageCtxId,
                component: {
                    parent_name: 'seller_card_about_me_list'
                },
                element: {
                    type: 'text',
                    metadata: 'Skill tests',
                    position: biData.position,
                    visible: true
                }
            }
        },
        seller_card_about_me_skill_tests_test_name = {
            ...baseBiData,
            group: 'seller_card_about_me_skill_tests_test_name_impression',
            page: {
                ...baseBiData.page,
                component: { ...baseBiData.page.component, name: 'seller_card_about_me_skill_tests_test_name' },
                element: {
                    ...baseBiData.page.element,
                    text: title,
                    name: 'seller_card_about_me_skill_tests_test_name',
                    sub_element_count: 1
                }
            }
        },
        seller_card_about_me_skill_tests_score = {
            ...baseBiData,
            group: 'seller_card_about_me_skill_tests_score_impression',
            page: {
                ...baseBiData.page,
                component: { ...baseBiData.page.component, name: 'seller_card_about_me_skill_tests_score' },
                element: {
                    ...baseBiData.page.element,
                    text: `${scoreFragment}/10`,
                    name: 'seller_card_about_me_skill_tests_score',
                    sub_element_count: 2
                }
            }
        },
        seller_card_about_me_skill_tests_score_label = {
            ...baseBiData,
            group: 'seller_card_about_me_skill_tests_score_label_impression',
            page: {
                ...baseBiData.page,
                component: { ...baseBiData.page.component, name: 'seller_card_about_me_skill_tests_score_label' },
                element: {
                    ...baseBiData.page.element,
                    text: statusText,
                    name: 'seller_card_about_me_skill_tests_score_label',
                    sub_element_count: 3
                }
            }
        };

    return (
        <li>
            <WithImpressions value={seller_card_about_me_skill_tests_test_name} element="span">{title}</WithImpressions>
            <WithImpressions value={seller_card_about_me_skill_tests_score} element="strong">{scoreFragment}<small>/10</small></WithImpressions>
            <WithImpressions value={seller_card_about_me_skill_tests_score_label} element="span" className={statusClassname}>{statusText}</WithImpressions>
        </li>
    );
}

Test.propTypes = {
    title: PropTypes.string,
    score: PropTypes.number,
    status: PropTypes.string,
    biData: PropTypes.object
};

Test.defaultProps = {
    title: '',
    score: 0,
    status: '',
    biData: {}
};



// WEBPACK FOOTER //
// ./src/common/InfoPanel/SellerProfile/SkillTests/Test.js